// extracted by mini-css-extract-plugin
export default {"FormSelectInput":"FormSelectInput_FormSelectInput__Nujuo"};